import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: theme.spacing(0.5),
  },
  chipContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    overflowY: 'auto',
    border: '1px solid #ccc',
    padding: theme.spacing(0.5),
    width: '100%',
    alignItems: 'center',
    borderRadius: '4px',
    maxHeight: '128px',
  },
  chipList: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    width: '100%',
  },
  chip: {
    display: 'flex',
    alignItems: 'center',
    margin: theme.spacing(0.5),
    whiteSpace: 'nowrap',
    height: '24px',
    justifyContent: 'space-between',
    minWidth: '120px',
    border: '1px #20427E33 solid',
  },
  input: {
    flexGrow: 1,
    border: 'none',
    outline: 'none',
    padding: theme.spacing(0.5),
    minWidth: '30px',
    whiteSpace: 'nowrap',
  },
}));

export default useStyles;
